export default "__VITE_ASSET__ByJth0$c__"